/**
 * プロジェクトタイトル
 */
export const TITLE = {
  // タイトルバー
  TITLE_BAR: 'BRIDGITAL-Contract',
  // タイトルフッダー
  TITLE_FOOTER: 'BRIDGITAL-Contract',
};

/**
 * 本番ドメイン
 */
export const PROD_DOMAIN = '';

/**
 * auth0設定情報(検証/開発)
 */
export const auth0_dev = {
  production: false,
  AUTH0_DOMAIN: 'tpn-hsj-dev.au.auth0.com', // ApplicationsのDomain(auth0情報)
  AUTH0_CLIENT_ID: 'pylb31T6omi1NbJlkpuo2ZIHdRhQf1c4', // ApplicationsのClient ID(auth0情報)
  AUDIENCE: 'https://aws-jwt-authorizer', // APIsのAPI Audience(auth0情報)
  API_URL: 'https://*', // トークン付与対象APIエンドポイント
};

/**
 * auth0設定情報(本番)
 */
export const auth0_prod = {
  production: false,
  AUTH0_DOMAIN: '', // ApplicationsのDomain(auth0情報)
  AUTH0_CLIENT_ID: '', // ApplicationsのClient ID(auth0情報)
  AUDIENCE: '', // APIsのAPI Audience(auth0情報)
  API_URL: 'https://*', // トークン付与対象APIエンドポイント
};

/**
 * 国際化（i18n）設定
 */
export const environment_i18n = {
  production: false,
  defaultLang: 'ja',
};
